<template>
    <div>
        <h5>What's the status of the Cassette?</h5>
        <w-button class="w-100 mb-2" @click="update(100)">
            Replaced Cassette
        </w-button>

        <w-button class="w-100" @click="$emit('update')">
            Did not replace Cassette
        </w-button>
        <small class="text-danger" v-if="error">{{error}}</small>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { lambda } from '@/amplify'

export default {
    name: 'Cassette',
    data () {
        return {
            error: null
        }
    },
    methods: {
        update (value) {
            this.error = null
            lambda('managePod', {
                podId: this.pool.pods[0].podId,
                refillableReq: {
                    padPctLeft: value
                }
            }).then(data => {
                if (data.code === 'OK') this.$emit('update')
                else this.error = 'Something went wrong'
            }).catch(err => {
                this.error = err.message || 'Something went wrong'
            })
        }
    },
    computed: {
        ...mapGetters({
            pool: 'pools/pool'
        })
    }
}
</script>

<style scoped>
    .update-button {
        border: 2px solid #47a4cb;
        color: #47a4cb;
        border-radius: 25px;
        margin-top: 30px;
        cursor: pointer;
    }
</style>
